// i18n area 'backups' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/backups.sr-Latn-RS.meta.json.
import type { enUS } from './backups'

export const srLatnRS: typeof enUS = {
  ckpt: {
    contents: 'Prima',
    contentsHint:
      'Šta ovde sme da sleti. „Checkpoints“ je konfiguracija klastera, „Rezervne kopije podataka“ su kopije VM: dva čitanja se sastavljaju, jedno odredište može primiti oba.',
    content: { checkpoints: 'Checkpoints', backups: 'Rezervne kopije podataka' },
    destinationsTitle: 'Odredišta bekapa',
    checkpointsTitle: 'Checkpointi',
    restoreTitle: 'Vraćanje',
    addDestination: 'Dodaj odredište',
    addDestinationTitle: 'Dodajte odredište bekapa',
    editDestinationTitle: 'Izmenite odredište',
    storage: 'Storage',
    storageHint: 'Dir-like storage (dir/NFS/CIFS/CephFS) — artefakti su obične datoteke pod namespaceom platforme.',
    schedule: 'Raspored',
    scheduleNone: 'Samo ručno',
    scheduleHourly: 'Svakog sata',
    scheduleDaily: 'Dnevno',
    scheduleWeekly: 'Nedeljno',
    scheduleHour: 'Sat',
    scheduleWeekday: 'Dan',
    scheduleHint:
      'Planirani checkpointi nemaju operatera koji ukucava masterpass: tajne iz keystorea pakuju se kao placeholderi.',
    retention: 'Retention',
    retentionHint:
      'Koliko planiranih checkpointa zadržati — sweeper uklanja najstarije preko tog broja. Ručni checkpointi i checkpointi pre vraćanja nikada se ne uklanjaju.',
    paused: 'Pauzirano',
    pausedHint:
      'Operaterovo zamračenje: dok pauza traje, na ovom odredištu ništa se ne planira i ništa se ne orezuje — policy za podatke i checkpointi podjednako. Izvršavanja u toku nikada se ne diraju.',
    orphanRuns: '{n} osirotelih izvršavanja',
    orphanRunsHint:
      'Planirana izvršavanja policy koje više ne postoje na ovom odredištu: nikakva retention ih ne upravlja — nikad brojana, nikad orezivana — i briše ih samo ruka. Sočivo „backups“ u tvirt diagnose imenuje uklonjene policy.',
    rescan: 'Ponovo usvoji artefakte',
    rescanTitle: 'Ponovno usvajanje artefakata za {name}',
    rescanHint:
      'Ponovo gradi katalog rezervnih kopija (VM/CT/App) iz manifesta artefakata na odredištu. Postojeći redovi se nikad ne diraju; kopije nepoznatih politika ostaju siročići (nikad se automatski ne orezuju). Potez posle bootstrap obnove.',
    masterpassDrWarning:
      'Scenario katastrofe: LUKS diskovi se vraćaju SAMO iz checkpointa SA masterpass-om. Planirani checkpointi pakuju čuvare mesta — povremeno napravite ručni checkpoint sa masterpass-om.',
    policy: {
      title: 'Policy rezervnih kopija podataka',
      hint: 'Imenovane policy: koji objekti (kind, tagovi, scopeovi), koliko često, kada izvršavanje sme da krene i koliko kopija zadržati. Gest upisa ostaje vlasniku objekta: tagovi se dodeljuju na njegovom sopstvenom scopeu.',
      add: 'Dodaj policy',
      column: 'Policy podataka',
      name: 'Naziv',
      nameHint:
        'Oznaka policy, jedinstvena unutar odredišta. Izvršavanja prate stabilni id policy: preimenovanje je besplatno; brisanje čini njena izvršavanja siročićima (više se ne broje niti orezuju).',
      kindLocked: 'Porodica objekata postojeće policy ne može se promeniti: napravite novu policy.',
      kindLabel: 'Objekti',
      kind: { vm: 'Virtuelne mašine', ct: 'Kontejneri', app: 'Aplikacije' },
      tags: 'Selektor tagova',
      tagsHint:
        'Parovi tag=vrednost odvojeni zapetama, u AND-u. Prazni tagovi i scopeovi ne biraju ništa — nikada „sve“.',
      scopes: 'Scopeovi',
      scopesHint: 'Putanje scopeova (podstabla), odvojene zapetama, međusobno u OR-u.',
      windowStart: 'Prozor od',
      windowEnd: 'Prozor do',
      windowHint:
        'Prozor izvršavanja (HH:MM, lokalno vreme; početak iza kraja preskače ponoć). Upravlja samo POČETKOM: izvršavanje koje ga prekorači nikada se ne ubija.',
      mode: 'Režim',
      modeHint: 'Inkrementalni jaše na porodici serija; prekinuta serija degradira u full, rečeno u dnevniku.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementalni',
      requireQuiesce: 'Zahtevaj quiesce (guest agent)',
      paused: 'Policy pauzirana',
      retentionNone: 'Zadrži sve',
      retentionCount: 'Broj',
      retentionGfs: 'GFS prstenovi',
      gfs: { keepLast: 'Poslednje', daily: 'Dnevne', weekly: 'Nedeljne', monthly: 'Mesečne', yearly: 'Godišnje' },
      gfsHint:
        'Za svaki prsten zadržava se najnovija kopija iz svakog od poslednjih N perioda. Zadržana kopija drži u životu ceo svoj lanac — nikada baza sa siročićima.',
      lastRun: 'Poslednje izvršavanje',
      neverRan: 'nikada izvršeno'
    },
    lastCheckpoint: 'Poslednji checkpoint',
    neverRun: 'Nikada kreirano',
    createNow: 'Kreiraj checkpoint',
    createNowTitle: 'Kreirajte checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Štiti tajne vrednosti u keystoreu (argon2id → AES-256-GCM, po vrednosti). Nikada se ne čuva: sačuvajte ga — bez njega vraćanje daje placeholdere umesto pravih tajni.',
    masterpassEmptyHint: 'Ostavite prazno da se umesto tajni upakuju eksplicitni placeholderi.',
    createStarted: 'Checkpoint u toku…',
    destinationInUseError: "'{name}' još sadrži checkpointe — prvo ih obrišite.",
    origin: 'Poreklo',
    originManual: 'ručno',
    originSchedule: 'planirano',
    originPreRestore: 'pre vraćanja',
    originPreChange: 'pre izmene',
    preChangeRetention: 'Checkpointi pre izmene',
    preChangeRetentionHint:
      'Prazno = isključeno. Prvi upis konfiguracije posle perioda mirovanja ovde zamrzava prethodno stanje (poreklo „pre izmene“); najnoviji se čuvaju do broja — sopstvena retencija, podložna orezivanju.',
    diffTitle: 'Pregled izmena',
    diffFailed: 'Pregled nije uspeo',
    diffRetry: 'Pokušaj ponovo',
    diffCounts: '{changed} za izmenu · {missing} za kreiranje · {extra} viška · {equal} identično',
    diffChanged: 'menja se',
    diffMissing: 'bio bi kreiran',
    diffExtra: 'bio bi obrisan',
    diffJsonb: 'jsonb reference nije moguće proveriti pre primene',
    diffSecret: 'zapečaćena polja, neuporediva',
    diffMore: 'još {n}…',
    diffNeeded: 'Pokretanje se aktivira kad pregled odražava izbor.',
    phase: 'Stanje',
    phaseRunning: 'u toku',
    phaseComplete: 'završeno',
    phaseError: 'greška',
    secrets: 'Tajne',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholderi',
    size: 'Veličina',
    created: 'Kreirano',
    destination: 'Odredište',
    download: 'Preuzmi .tvbk',
    deleteCheckpoint: 'Obriši checkpoint',
    noCheckpoints: 'Još nema checkpointa — kreirajte jedan sa nekog odredišta.',

    // Round #156 (dialog standard): la superficie di lettura completa del
    // record di archivio — righe di dettaglio per i campi mai mostrati in tabella.
    families: 'Familije',
    generation: 'Generacija',
    completedAt: 'Završeno',
    errorDetail: 'Detalj greške',
    manifest: 'Manifest',
    restoreHint: 'Otpremite .tvbk artefakt: explorer prikazuje šta on nosi, a zatim birate šta vratiti i kako.',
    uploadFile: 'Otpremi .tvbk datoteku',
    uploading: 'Otpremanje…',
    uploadFailed: 'Artefakt nije moguće otvoriti',
    explorerTitle: 'Sadržaj checkpointa',
    checkpointFrom: 'Checkpoint klastera {cluster}, kreiran {when} ({origin}, generacija {generation})',
    otherCluster:
      'Ovaj checkpoint potiče sa DRUGOG klastera ({cluster}) — cross-cluster vraćanje stiže u budućoj rundi.',
    encrypted: 'šifrovano',
    objectsCount: 'objekata: {n}',
    mode: 'Režim',
    modeMerge: 'Merge — usklađuje: upsert izabranih, ništa ne briše',
    modeOverwrite:
      'Overwrite — checkpoint pobeđuje: familija izabrana u celini zamenjuje se cela (postojeći redovi kojih nema u checkpointu nestaju)',
    restoreMasterpassHint:
      'Masterpass sa kojim je checkpoint kreiran. Bez njega se šifrovane tajne vraćaju kao eksplicitni placeholderi.',
    checkMasterpass: 'Proveri',
    masterpassOk: 'Masterpass ispravan',
    masterpassWrong: 'Pogrešan masterpass',
    parachuteDestination: 'Padobransko odredište',
    parachuteHint: 'Pre nego što dodirne ijedan red, zadatak ovde kreira automatski checkpoint pre vraćanja.',
    summaryTitle: 'Šta će se desiti',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'cela familija',
    summaryObjects: 'izabranih objekata: {n}',
    confirmHint: 'Ukucajte ime klastera ({name}) da potvrdite — vraćanje prepisuje deklarisanu konfiguraciju.',
    confirmField: 'Ime klastera',
    startRestore: 'Vrati',
    restoreRunning: 'Vraćanje u toku…',
    restoreDone: 'Vraćanje završeno — reconcileri konvergiraju ka novoj deklaraciji.',
    restoreFailed: 'Vraćanje nije uspelo',
    discard: 'Odbaci',
    selectionEmpty: 'Izaberite bar jednu familiju ili jedan objekat.'
  },

  backup: {
    intro: {
      title: 'Rezervne kopije podataka VM-ova i kontejnera',
      subtitle: 'Gradivni blokovi kojima se služi spoljni softver za rezervne kopije',
      whatItIs:
        'TVirt izlaže četiri primitive: quiesced snimke, praćenje promena po disku, NBD eksport samo za čitanje i eksport konfiguracije. Njima upravljaju Veeam, Bacula, Acronis i društvo.',
      whatItIsNot:
        'TVirt nije proizvod za rezervne kopije: ništa ne planira, ne primenjuje retenciju i ne čuva nikakvu arhivu vaših podataka. Retencija, katalozi i politike vraćanja ostaju na softveru koji već koristite.'
    },
    cbt: {
      title: 'Praćenje promena',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Stanje',
      colBitmaps: 'Bitmape',
      colObservedAt: 'Zabeleženo',
      colChangeId: 'Change ID',
      colMechanic: 'Mehanizam',
      stateActive: 'Aktivno',
      stateInactive: 'Isključeno',
      stateInconsistent: 'Nedosledno — sledeća rezervna kopija mora biti puna',
      stateBroken: 'Lanac prekinut — isključite, pa uključite kao novi lanac',
      stateSnapshots: 'Uvek uključeno — delta između snimaka',
      stateUnavailable: 'Nedostupno na ovom disku',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitmapa',
        'rbd-snapdiff': 'Diff Ceph snimaka',
        'lvm-thin-delta': 'Delta thin poola',
        none: 'Nema'
      },
      empty:
        'Nema VM diska. Praćenje promena čita se po disku: uključite ga na qcow2 disku ili pravite snimke na rbd/SAN.',
      chainBroken: 'Lanac prekinut',
      chainBrokenText:
        'Prekinut događajem {reason}: {bitmaps}. Isključite bitmapu (lanac je izgubljen, sledeća kopija je puna), pa je uključite kao novi lanac.',
      lineages: 'Epohe',
      epochFrozen: 'zamrznuta u snimku {snapshot}',
      epochLost: 'izgubljena ({cause})',
      epochRecording: 'beleži na glavi',
      milestones: 'Prekretnice (snimci)',
      enable: 'Uključi praćenje promena',
      disable: 'Isključi',
      reset: 'Resetuj',
      changedAreas: 'Promenjene oblasti',
      denied: 'Nemate dozvolu na ovoj VM',
      enableTitle: 'Uključi praćenje promena',
      disableTitle: 'Isključi praćenje promena',
      resetTitle: 'Resetuj bitmapu',
      areasTitle: 'Promenjene oblasti',
      bitmapName: 'Naziv bitmape',
      bitmapNameHint: 'Sopstveni naziv: tvirt- i tvbk- pripadaju platformi',
      granularity: 'Granularnost (bajtovi)',
      granularityHint: 'Stepen dvojke; podrazumevano 65536',
      bitmap: 'Bitmapa',
      disableHint: 'Uklanja bitmapu i celu istoriju njenih epoha: sledeća kopija mora biti puna.',
      resetHint: 'Prazni bitmapu — nova osnova: change ID stariji od reseta više se ne može složiti.',
      areasFrom: 'Od snimka',
      areasTo: 'Do snimka',
      areasRun: 'Izračunaj',
      areasResult: '{count} promenjenih oblasti, {bytes}',
      areasEmpty: 'Nema promenjenih oblasti između dva snimka',
      areasZero: 'nule',
      areasMore: 'prikazano prvih {shown} od {count}',
      submit: 'Potvrdi',
      error: 'Radnja praćenja promena nije uspela'
    },
    exports: {
      title: 'Otvoreni NBD eksporti',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Snimak',
      colBitmap: 'Bitmapa',
      colPhase: 'Faza',
      colNode: 'Čvor',
      colEndpoint: 'Endpoint',
      colExpires: 'Ističe',
      colCreated: 'Otvoreno',
      colError: 'Greška',
      phase: {
        preparing: 'Priprema',
        ready: 'Spreman',
        closed: 'Zatvoren',
        error: 'Neuspeo'
      },
      expiresIn: 'za {minutes} min',
      expired: 'istekao',
      empty: 'Nema exporta. Sesija čitanja služi jedan disk na jednom snapshotu NBD klijentu; sesija pisanja puni netaknut disk zaustavljene VM. Obe umiru po isteku.',
      endpointHint: 'TLS sa CA klastera; naziv eksporta je ulaznica — umire sa sesijom',
      closeDenied: 'Nemate dozvolu da zatvarate eksporte ove VM',
      open: 'Otvori NBD eksport',
      openTitle: 'Otvori NBD eksport',
      openDisk: 'Disk',
      openBitmap: 'Bitmapa (opciono)',
      openBitmapHint:
        'Objavljuje epohu te bitmape zamrznutu u ovom snimku kao meta-context promenjenih ekstenata (samo qcow2 diskovi)',
      openTtl: 'Trajanje (minuti)',
      openSubmit: 'Otvori',
      openError: 'Eksport nije mogao da se otvori',
      colMode: 'Režim',
      mode: {
        read: 'Čitanje',
        write: 'Pisanje'
      },
      caCertificate: 'CA klastera',
      caCopy: 'Kopiraj PEM',
      caDownload: 'Preuzmi ca-cert.pem',
      caHint: 'Zapišite PEM u ca-cert.pem u privatnom direktorijumu i povežite se sa nbds://…?tls-certificates=<direktorijum> (nbdcopy, nbdinfo) ili --object tls-creds-x509,dir=<direktorijum>,endpoint=client (qemu-img)',
      caAbsent: 'Sesija ne nosi CA (nema PKI)',
      openWrite: 'Otvori export za pisanje',
      openWriteTitle: 'Otvori export za pisanje',
      openWriteIntro: 'Disk mora biti netaknut: rođen prazan, nikad pisan, bez snapshota; VM zaustavljena. Vraćanje PUNI disk, ne popravlja ga. Dok je sesija otvorena, VM se ne pokreće, ne pravi snapshot, ne klonira se, a disk se ne premešta.',
      openWriteSubmit: 'Otvori',
      openWriteError: 'Export za pisanje nije mogao da se otvori',
      openWriteDenied: 'Nedostaje vam vm.restore.data na ovoj VM',
      openWriteStopped: 'Zaustavite VM da biste otvorili export za pisanje',
      fromDescription: 'Napravi VM iz opisa',
      fromDescriptionTitle: 'Napravi VM iz opisa',
      fromDescriptionIntro: 'Opis iz export-vm-meta vraća se kao zaustavljena VM sa praznim diskovima opisane geometrije — spremna za exporte za pisanje, disk po disk. Bajtovi ne prolaze ovuda: nosi ih restore-disk (CLI) ili NBD klijent proizvoda za rezervne kopije.',
      fromDescriptionDoc: 'Opis (JSON)',
      fromDescriptionDocHint: 'Nalepite dokument iz export-vm-meta ili izaberite datoteku',
      fromDescriptionFile: 'Izaberi datoteku…',
      fromDescriptionInvalid: 'Tekst nije JSON dokument',
      fromDescriptionName: 'Ime nove VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Vaš početni scope',
      fromDescriptionStorage: 'Skladište diskova',
      fromDescriptionStorageHint: 'Svaki disk se rađa ovde, u podrazumevanom formatu skladišta',
      fromDescriptionMetadataStorage: 'Skladište metapodataka',
      fromDescriptionSameAsStorage: 'Isto kao za diskove',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Bez bridža ni mreže VM se rađa bez kartica',
      fromDescriptionNetwork: 'Logička mreža (fabric/mreža)',
      fromDescriptionSubmit: 'Napravi',
      fromDescriptionError: 'VM nije mogla da se napravi',
      fromDescriptionDone: 'VM napravljena: {name}',
      fromDescriptionOpen: 'Otvori VM',
      fromDescriptionDenied: 'Nedostaje vam vm.create',
      fromDescriptionStillRunning: 'Pravljenje još traje: čeka se dalje'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Rezervne kopije podataka VM',
      titleOnVm: 'Rezervne kopije podataka',
      empty:
        'Nema kopije. Kopija prenosi diskove, varstore UEFI i stanje vTPM na odredište i nadživljava virtuelnu mašinu.',
      colVm: 'VM',
      colCreated: 'Napravljena',
      colPhase: 'Ishod',
      colDestination: 'Odredište',
      colContains: 'Sadržaj',
      colSize: 'Veličina',
      colOrigin: 'Poreklo',
      colMode: 'Vrsta',
      retentionChip: 'Zadržavanje',
      retentionHint:
        'Zadržavanje odredišta može obrisati ovu kopiju ne pitajući: rođena je iz rasporeda. Ručne kopije se nikada ne pometu.',
      policyRemoved: 'Policy uklonjena: {name}',
      policyRemovedHint:
        'Policy koja je planirala ovaj backup više ne postoji: nikakva retention ga ne upravlja (nikad se ne orezuje automatski) — obrišite ga ručno kad više ne treba.',
      phase: {
        running: 'U toku',
        complete: 'Završena',
        error: 'Neuspela'
      },
      origin: {
        manual: 'Ručna',
        schedule: 'Zakazana'
      },
      mode: {
        full: 'Puna',
        incremental: 'Inkrementalna'
      },
      contains: {
        disks: 'Diskovi',
        varstore: 'Varstore UEFI',
        vtpm: 'Stanje vTPM',
        snapshots: 'Snimci'
      },
      vmState: {
        stopped: 'VM ugašena',
        running: 'VM radi (toplo)'
      },
      artifactClass: { metadata: 'Metapodaci', data: 'Podaci', secret: 'Tajna' },
      detail: {
        tabOverview: 'Pregled',
        tabArtefact: 'Artefakt',
        id: 'Identifikator',
        scope: 'Opseg',
        vmState: 'Stanje VM pri kopiranju',
        pointInTime: 'Trenutak podataka',
        completedAt: 'Završena',
        node: 'Čvor koji je kopirao',
        error: 'Greška',
        path: 'Fascikla na skladištu',
        checksum: 'sha256 manifesta',
        secretsExposed: 'Osetljiv materijal u otvorenom obliku',
        secretsExposedYes: 'Da — odredište ne šifruje',
        secretsExposedNo: 'Ne',
        baseBackup: 'Osnovna kopija',
        tabManifest: 'Manifest',
        manifestHint:
          'Otvoreni indeks artefakta: jedan fajl po redu sa svojim sha256. Fascikla se proverava i bez TVirt-a — dovoljni su qemu-img, tar i jq.',
        manifestEmpty: 'Manifest ne navodi fajlove.',
        manifestError: 'Manifest se ne može pročitati',
        colEntry: 'Fajl',
        colClass: 'Klasa',
        colSha: 'sha256'
      },
      create: {
        action: 'Kopiraj sada',
        title: 'Kopiraj sada',
        submit: 'Pokreni kopiju',
        destination: 'Odredište',
        destinationHint: 'Samo odredišta koja primaju kopije.',
        noDestinations: 'Nijedno odredište ne prima kopije: napravite ga u Sistem → Checkpoints.',
        contentsHint:
          'Putuju svi diskovi, varstore UEFI i stanje vTPM. Poslednja dva su suština: zapečaćen gost mora ponovo da se podigne.',
        error: 'Kopija nije krenula',
        stillRunning: 'Kopija još traje — kopiranje se nastavlja i ako zatvorite.',
        vmRunning:
          'Mašina je {phase}: rezervna kopija traži stabilnu VM — ugašenu za hladno kopiranje, pokrenutu za toplo.'
      },
      restore: {
        action: 'Vrati',
        title: 'Vrati',
        intro: 'Vraćanje je nepovratno. Izaberite gde se podaci vraćaju: u novu mašinu ili preko izvorne.',
        modeNewVm: 'Vrati u NOVU VM',
        modeNewVmHint:
          'Ne dira ništa što postoji — time se kopija proverava. Novi identifikator i sveže iskovane MAC adrese.',
        modeOver: 'Prebriši izvornu VM',
        modeOverHint: 'Uništava trenutne podatke ciljne VM, bez povratka. Mašina mora biti ugašena.',
        newName: 'Ime nove VM',
        newNameHint: 'Mora biti slobodno u ciljnom opsegu.',
        storage: 'Skladište za diskove',
        storageHint: 'Obavezno: manifest beleži veličinu i format diska, nikada skladište na kom je ležao.',
        metadataStorage: 'Skladište za varstore i vTPM',
        metadataStorageHint: 'Gde sleću UEFI identitet i stanje vTPM.',
        sameAsStorage: 'Isto kao diskovi',
        bridge: 'Bridge domaćina',
        bridgeHint:
          'Svaka zabeležena mrežna kartica vraća se na ovaj bridge sa novom MAC adresom. Ostavljeno prazno, VM se rađa bez kartica — sigurnija podrazumevana vrednost.',
        overwriteTitle: 'Upravo ćete prebrisati ovu VM',
        overwriteName: 'Ime',
        overwriteId: 'Identifikator',
        overwriteDisks: 'Diskovi koji će biti prebrisani',
        overwriteNoDisks: 'Nema diskova.',
        overwriteKeeps:
          'Netaknuti ostaju identifikator, ime, opseg, mrežne kartice i MAC adrese: kopija su PODACI, konfiguracija je checkpoint.',
        confirmField: 'Ime VM',
        confirmHint: 'Ukucajte {name} za potvrdu.',
        targetLoading: 'Čitanje ciljne VM…',
        targetRunning: 'Ciljna VM je {phase}: vraćanje prebrisuje bajtove ispod gosta, pa je traži ugašenu.',
        targetGone: 'Izvorna VM se više ne može pročitati: ostaje vraćanje u novu VM.',
        onlyComplete: 'Kopija je {phase}: vratiti može samo završena kopija.',
        submitNewVm: 'Vrati u novu VM',
        submitOver: 'Prebriši',
        error: 'Vraćanje nije krenulo',
        stillRunning: 'Vraćanje još traje — kopiranje celih diskova traži vreme.'
      }
    },
    guest: {
      title: {
        ct: 'Rezervne kopije podataka kontejnera',
        app: 'Rezervne kopije podataka App-ova'
      },
      tabTitle: 'Rezervne kopije',
      empty: 'Nema kopija. Kopija prenosi trajne podatke na odredište i nadživljava svoj objekat.',
      colSubject: {
        ct: 'Kontejner',
        app: 'App'
      },
      colCreated: 'Napravljena',
      colPhase: 'Ishod',
      colDestination: 'Odredište',
      colContains: 'Sadržaj',
      colSize: 'Veličina',
      colOrigin: 'Poreklo',
      policyRemoved: 'Policy uklonjena: {name}',
      policyRemovedHint:
        'Policy koja je planirala ovaj backup više ne postoji: nikakva retention ga ne upravlja (nikad se ne orezuje automatski) — obrišite ga ručno kad više ne treba.',
      phase: {
        running: 'U toku',
        complete: 'Završena',
        error: 'Neuspela'
      },
      origin: {
        manual: 'Ručna',
        schedule: 'Planirana'
      },
      state: {
        stopped: 'Objekat zaustavljen',
        running: 'Objekat radi (zamrznut)'
      },
      contains: {
        rootfs: 'Stablo rootfs',
        config: 'Konfiguracija',
        volumes: 'Trajni volumeni',
        root: 'Trajni root'
      },
      artifactClass: {
        metadata: 'Metapodaci',
        data: 'Podaci',
        secret: 'Tajna'
      },
      create: {
        action: 'Napravi kopiju sada',
        title: 'Nova rezervna kopija',
        submit: 'Pokreni kopiju',
        error: 'Kopija nije krenula',
        destination: 'Odredište',
        destinationHint: 'Samo odredišta koja prihvataju rezervne kopije podataka.',
        noDestinations:
          'Nijedno odredište ne prihvata rezervne kopije podataka: dodajte odredištu „Rezervne kopije podataka“.',
        hint: {
          ct: 'Putuje celo stablo rootfs, verno (numerički vlasnici, xattr, ACL), plus deklarisana konfiguracija u manifestu. Kontejner koji radi se ZAMRZAVA za celo pakovanje: crash-consistent kopija, deklarisana.',
          app: 'Putuju SAMO trajni volumeni (i trajni root), plus konfiguracija u manifestu. Efemerno je isključeno ratifikacijom i manifest ga imenuje; env vrednosti deklarisane tajnima ne putuju.'
        },
        stillRunning: 'Kopija još traje — pakovanje celih stabala traje.'
      },
      detail: {
        tabOverview: 'Pregled',
        tabManifest: 'Manifest',
        id: 'Identifikator',
        scope: 'Opseg',
        state: 'Stanje pri kopiji',
        pointInTime: 'Podaci u trenutku',
        completedAt: 'Zaključena',
        node: 'Čvor koji je kopirao',
        error: 'Greška',
        path: 'Fascikla na skladištu',
        checksum: 'sha256 manifesta',
        manifestHint:
          'Indeks artefakta: jedan zapis po datoteci sa svojim sha256 — bez heševa je „kopija postoji“ čin vere.',
        manifestError: 'Manifest se ne može pročitati',
        manifestEmpty: 'Nema artefakata u manifestu.',
        colEntry: 'Datoteka',
        colClass: 'Klasa',
        colSha: 'sha256',
        excluded: 'Isključeno ratifikacijom (ne putuje)',
        secretKeys: 'Izostavljeni tajni env ključevi (#307) — ponovo ih unesite posle vraćanja'
      },
      restore: {
        action: 'Vrati',
        title: 'Vraćanje',
        submit: 'Vrati',
        error: 'Vraćanje nije krenulo',
        stillRunning: 'Vraćanje još traje — raspakivanje celih stabala traje.',
        onlyComplete: 'Kopija je {phase}: vratiti može samo završena kopija.',
        asNew: {
          ct: 'U NOVI kontejner — ništa ne uništava: gest kojim se kopija proverava',
          app: 'U NOVI App — ništa ne uništava: gest kojim se kopija proverava'
        },
        over: {
          ct: 'PREKO izvornog kontejnera — celo stablo rootfs se zamenjuje',
          app: 'PREKO izvornog App-a — sadržaj svakog trajnog volumena se zamenjuje'
        },
        name: 'Naziv novog objekta',
        storage: 'Skladište',
        storageHint: 'Gde vraćeni podaci sleću — manifest nikad ne beleži izgubljeni pool.',
        storageDeclared: 'Skladišta deklarisana u manifestu',
        bridge: 'Most domaćina',
        bridgeHint:
          'Svaka zabeležena kartica vraća se na ovaj most sa svežim MAC-om. Prazno = rađa se nepovezan, najsigurnije podrazumevano.',
        node: 'Čvor',
        nodeHint: 'Član na kome se App ponovo rađa: čvor je identitet klastera i nikad ne dolazi iz manifesta.',
        secretKeysWarning:
          'Env vrednosti deklarisane tajnima ne putuju u kopiji: ponovo rođena kopija ih želi unete (log zadatka imenuje ključeve).',
        overInventory: 'Upravo ćete prepisati ovaj objekat',
        confirmType: 'Upišite {name} za potvrdu',
        targetGone: 'Izvorni objekat više se ne može pročitati: ostaje vraćanje kao novo.',
        targetLoading: 'Čitanje ciljnog objekta…',
        targetRunning: 'Ciljni objekat radi: vraćanje zamenjuje bajtove pod gostom pa ga želi zaustavljenog.'
      }
    }
  }
}
